(function () {
  function withSectionParam(url, sectionId) {
    try {
      var resolved = new URL(url, window.location.origin);
      resolved.searchParams.set('section_id', sectionId);
      return resolved.toString();
    } catch (error) {
      return url;
    }
  }

  function bindBundleButton(btn) {
    if (!btn || btn.getAttribute('data-dlux-bundle-bound') === 'true') return;

    btn.setAttribute('data-dlux-bundle-bound', 'true');
    btn.addEventListener('click', function () {
      var raw = btn.getAttribute('data-variant-ids') || '';
      var ids = raw
        .split(',')
        .map(function (s) {
          return parseInt(s.trim(), 10);
        })
        .filter(function (n) {
          return !isNaN(n);
        });
      if (!ids.length) return;
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('loading');
      var spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
      var items = ids.map(function (id) {
        return { id: id, quantity: 1 };
      });
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      // Ask cart/add.js to return the drawer/notification section HTML so the cart UI
      // has markup to paint; without this renderContents renders an empty drawer.
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
        body.sections_url = window.location.pathname;
      }
      fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (response) {
          if (response.status) throw new Error(response.description || 'add failed');
          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(response);
          }
        })
        .catch(function (error) {
          console.error('[dlux-upsell-banner] add failed', error);
        })
        .finally(function () {
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          btn.removeAttribute('disabled');
        });
    });
  }

  function initBundleButtons(scope) {
    (scope || document).querySelectorAll('[data-dlux-bundle-add]').forEach(bindBundleButton);
  }

  function hydrateBanner(root) {
    var baseUrl = root.getAttribute('data-base-url');
    var sectionId = root.getAttribute('data-section-id');
    if (!baseUrl || !sectionId) return;

    root.setAttribute('data-dlux-upsell-hydrate', 'loading');

    fetch(withSectionParam(baseUrl, sectionId), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText || String(response.status));
        }
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var replacement = doc.querySelector('[data-dlux-upsell-banner-root]');

        if (!replacement || replacement.getAttribute('data-dlux-upsell-hydrate') === 'pending') {
          throw new Error('Upsell banner did not render from base collection URL.');
        }

        root.replaceWith(replacement);
        initBundleButtons(replacement);
      })
      .catch(function (error) {
        console.error('[dlux-upsell-banner] hydrate failed', error);
        root.remove();
      });
  }

  function init() {
    initBundleButtons(document);
    document.querySelectorAll('[data-dlux-upsell-hydrate="pending"]').forEach(hydrateBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
